define('plugin/package/PackagePlugin',['require','lib/plugin/PluginAbstract','underscore','plugin/package/controller/PackageController','plugin/package/view/PackageInvoiceInstanceCollectionView','plugin/package/view/PackageInvoiceNotificationView','collection/ServiceCollection','plugin/product/collection/ProductCollection','plugin/package/collection/PackageInstanceCollection','plugin/package/view/PackageModuleListView','plugin/package/collection/PackageCollection','Config','handlebars','view/helper/TemplatePrecompiled','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
    var PackageController = require('plugin/package/controller/PackageController');
    var PackageInvoiceInstanceCollectionView = require('plugin/package/view/PackageInvoiceInstanceCollectionView');
    var PackageInvoiceNotificationView = require('plugin/package/view/PackageInvoiceNotificationView');

    var ServiceCollection = require('collection/ServiceCollection');
    var ProductCollection = require('plugin/product/collection/ProductCollection');
    var PackageInstanceCollection = require('plugin/package/collection/PackageInstanceCollection');
    var PackageModuleListView = require('plugin/package/view/PackageModuleListView');

    var PackageCollection = require('plugin/package/collection/PackageCollection');

    var Config = require('Config');
    var Handlebars = require('handlebars');
    var templateFor = require('view/helper/TemplatePrecompiled').templateFor;
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _collection: null,
        _detailsStepView: null,
        _serviceCollection: null,
        _productCollection: null,
        _attributeCollection: null,
        _invoiceCollection: null,

        _invoiceVisiblePackages: null,
        _isCollectionLoaded : false,

        _packageModuleRegions: {
            packageModule: '#sb_package_module',
        },

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initCollections();
            this.initRoutes();
            this.initTemplateHelpers();
            this.subscribeInvoiceViewEvents();

            this._invoiceVisiblePackages = [];
        },

        initCollections: function () {
            this._collection = new PackageCollection();
            this._serviceCollection = new ServiceCollection();
            this._productCollection = new ProductCollection();
            this._attributeCollection = new ProductCollection();
            this._invoiceCollection = new PackageInstanceCollection();
        },

        loadRelatedCollections: function () {
            var config = Config.getInstance();
            if(this._isCollectionLoaded){
                return;
            }

            this._serviceCollection.load();
            if (config.getPluginStatus('product')) {
                this._productCollection.load({data: {
                    'type': 'product'
                }});
            }
            if (config.getPluginStatus('paid_attributes')) {
                this._attributeCollection.load({data: {
                    'type': 'attribute'
                }});
            }
            this._isCollectionLoaded = true;
        },

        /**
         * Init step manager events
         */
        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);
        },

        /**
         * Initialize plugin modules
         */
        initModules: function (layout) {
            _.each(this._packageModuleRegions, function (selector, packageRegion) {
                layout.addRegion(packageRegion, selector);
            });

            if (layout.packageModule.$el.length && Config.getInstance().getOption('package_has_active_packages')) {

                this.loadRelatedCollections();

                layout.packageModule.show(new PackageModuleListView({
                    collection: this._collection,
                    serviceCollection: this._serviceCollection,
                    productCollection: this._productCollection,
                    attributeCollection: this._attributeCollection,
                }));
                this._collection.load();
            }
        },

        /**
         * Subscribe to show package view
         */
        subscribeInvoiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('invoice:layout').vent.on(
                'show', _.bind(this.onInvoiceLayoutShow, this)
            );
        },

        /**
         * Display package list view
         */
        onInvoiceLayoutShow: function (data) {
            var layout = data.view;
            var model = data.model;

            this._invoiceCollection.fetch({data: {
                'invoice_id': model.id
            }});

            this.loadRelatedCollections();
            var packagesView = new PackageInvoiceInstanceCollectionView({
                allowToEdit: data.paymentAllowed && this._allowToUsePackage(model),
                model: model,
                collection: this._invoiceCollection,
                serviceCollection: this._serviceCollection,
                productCollection: this._productCollection,
                attributeCollection: this._attributeCollection,
                visiblePackages: this._invoiceVisiblePackages
            });

            this.listenTo(packagesView, 'delete:package:instance', this.removePackageInstance);
            this.listenTo(packagesView, 'use:package:instance', this.applyPackageInstance);
            this.listenTo(packagesView, 'change:package:instance:visibility', _.bind(function (data) {
                this._invoiceVisiblePackages = data;
            }, this));

            var notificationView = new PackageInvoiceNotificationView({
                model: model
            });

            layout.getUsedPackageInstancesRegion().show(packagesView);
            layout.getPackageNotificationRegion().show(notificationView);
        },

        /**
         * Applies package to invoice
         *
         * @param {InvoiceModel} invoiceModel
         * @param {PackageInstanceModel} packageInstance
         */
        applyPackageInstance: function (invoiceModel, packageInstance) {
            invoiceModel.applyPackage(packageInstance.get('id'));
        },

        /**
         * Remove instance from invoice
         *
         * @param {InvoiceModel} invoiceModel
         * @param {PackageInstanceModel} packageInstance
         */
        removePackageInstance: function (invoiceModel, packageInstance) {
            invoiceModel.removePackage(packageInstance.get('id'));
        },

        /**
         * Check if possible to use package in this invoice
         *
         * @param {InvoiceModel} model
         * @return {boolean}
         * @private
         */
        _allowToUsePackage: function (model) {
            var allow = false;
            if (model.get('status') !== 'new') {
                return false;
            }
            if (model.get('rest_amount') > 0) {
                return false;
            }
            model.get('lines').each(function (model) {
                if (model.get('type') !== 'promotion' && model.get('type') !== 'package' && model.get('type') !== 'membership') {
                    allow = true;
                }
            }, this);

            return allow;
        },

        /**
         * Before details step shown add additional fields region
         *
         * @param {DetailsStep} step
         * @param {DetailsView} view
         * @param {Marionette.Region} region
         */
        beforeDetailsShow: function (step, view, region) {
            this._detailsStepView = view;
        },

        /**
         * Inits membership routes
         */
        initRoutes: function () {
            var packageRouter = new AppRouter({
                appRoutes: {
                    'packages/my(/:hightlighted)(/)': 'my',
                    'package/buy/:id(/:date)(/)': 'buy',
                    'packages(/:id)(/services/:services)(/products/:products)(/)': 'index',
                },
                menuItem: 'package',
                controller: new PackageController({
                    app: this.getOption('app'),
                    collection: this._collection,
                    serviceCollection: this._serviceCollection,
                    productCollection: this._productCollection,
                    attributeCollection: this._attributeCollection
                })
            });
        },

        /**
         * Add package handkebar helpers
         */
        initTemplateHelpers: function () {
            Handlebars.registerPartial('package_header_part', templateFor('#package_header_part'));
            Handlebars.registerPartial('package_selected_list', templateFor('#package_selected_list'));
        }

    });

});
